import React from 'react';
import { SearchIcon, BellIcon, MapPinIcon, ClockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import FlightSearchForm from '../components/FlightSearchForm';
const HomePage = () => {
  return <div className="w-full" data-id="element-152">
      {/* Hero Section */}
      <section className="bg-blue-800 text-white py-16" data-id="element-153">
        <div className="container mx-auto px-4" data-id="element-154">
          <div className="max-w-3xl mx-auto text-center" data-id="element-155">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-156">
              Track Any Flight in Real-Time
            </h1>
            <p className="text-xl mb-8" data-id="element-157">
              Get instant alerts and updates for flight delays, gate changes,
              and more.
            </p>
            <div className="bg-white p-6 rounded-lg shadow-lg" data-id="element-158">
              <FlightSearchForm data-id="element-159" />
            </div>
          </div>
        </div>
      </section>
      {/* Features Section */}
      <section className="py-16 bg-white" data-id="element-160">
        <div className="container mx-auto px-4" data-id="element-161">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-162">
            Why Choose FlightTracker
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-163">
            <div className="text-center p-6 bg-gray-50 rounded-lg" data-id="element-164">
              <div className="inline-block p-3 bg-blue-100 rounded-full mb-4" data-id="element-165">
                <SearchIcon className="h-8 w-8 text-blue-600" data-id="element-166" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-167">Real-Time Tracking</h3>
              <p className="text-gray-600" data-id="element-168">
                Monitor any commercial flight worldwide with accurate,
                up-to-the-minute information.
              </p>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-lg" data-id="element-169">
              <div className="inline-block p-3 bg-blue-100 rounded-full mb-4" data-id="element-170">
                <BellIcon className="h-8 w-8 text-blue-600" data-id="element-171" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-172">
                Customizable Alerts
              </h3>
              <p className="text-gray-600" data-id="element-173">
                Get notified about delays, gate changes, cancellations, and more
                via email or SMS.
              </p>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-lg" data-id="element-174">
              <div className="inline-block p-3 bg-blue-100 rounded-full mb-4" data-id="element-175">
                <MapPinIcon className="h-8 w-8 text-blue-600" data-id="element-176" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-177">
                Airport Information
              </h3>
              <p className="text-gray-600" data-id="element-178">
                Access detailed airport maps, weather conditions, and terminal
                information.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Popular Flights Section */}
      <section className="py-16 bg-gray-50" data-id="element-179">
        <div className="container mx-auto px-4" data-id="element-180">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-181">
            Popular Flight Routes
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-182">
            {popularRoutes.map((route, index) => <Link to={`/search?from=${route.from.code}&to=${route.to.code}`} key={index} className="bg-white p-5 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-183">
                <div className="flex justify-between items-center mb-4" data-id="element-184">
                  <div data-id="element-185">
                    <p className="font-bold text-lg" data-id="element-186">{route.from.code}</p>
                    <p className="text-gray-600 text-sm" data-id="element-187">{route.from.city}</p>
                  </div>
                  <div className="text-gray-400 px-4" data-id="element-188">✈</div>
                  <div className="text-right" data-id="element-189">
                    <p className="font-bold text-lg" data-id="element-190">{route.to.code}</p>
                    <p className="text-gray-600 text-sm" data-id="element-191">{route.to.city}</p>
                  </div>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-192">
                  <ClockIcon className="h-4 w-4 mr-1" data-id="element-193" />
                  <span data-id="element-194">{route.duration}</span>
                  <span className="mx-2" data-id="element-195">•</span>
                  <span data-id="element-196">{route.flights} daily flights</span>
                </div>
              </Link>)}
          </div>
          <div className="text-center mt-10" data-id="element-197">
            <Link to="/search" className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-md transition-colors" data-id="element-198">
              View All Routes
            </Link>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-blue-700 text-white" data-id="element-199">
        <div className="container mx-auto px-4 text-center" data-id="element-200">
          <h2 className="text-3xl font-bold mb-6" data-id="element-201">
            Never Miss a Flight Update Again
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-202">
            Set up personalized flight alerts and stay informed about any
            changes to your travel plans.
          </p>
          <Link to="/alerts" className="inline-block bg-white text-blue-700 font-medium px-6 py-3 rounded-md hover:bg-gray-100 transition-colors" data-id="element-203">
            Create Flight Alert
          </Link>
        </div>
      </section>
    </div>;
};
// Mock data for popular routes
const popularRoutes = [{
  from: {
    code: 'JFK',
    city: 'New York'
  },
  to: {
    code: 'LAX',
    city: 'Los Angeles'
  },
  duration: '6h 15m',
  flights: 24
}, {
  from: {
    code: 'LHR',
    city: 'London'
  },
  to: {
    code: 'CDG',
    city: 'Paris'
  },
  duration: '1h 20m',
  flights: 32
}, {
  from: {
    code: 'SFO',
    city: 'San Francisco'
  },
  to: {
    code: 'SEA',
    city: 'Seattle'
  },
  duration: '2h 10m',
  flights: 18
}, {
  from: {
    code: 'DFW',
    city: 'Dallas'
  },
  to: {
    code: 'ORD',
    city: 'Chicago'
  },
  duration: '2h 30m',
  flights: 22
}, {
  from: {
    code: 'HND',
    city: 'Tokyo'
  },
  to: {
    code: 'ICN',
    city: 'Seoul'
  },
  duration: '2h 45m',
  flights: 16
}, {
  from: {
    code: 'DXB',
    city: 'Dubai'
  },
  to: {
    code: 'DEL',
    city: 'Delhi'
  },
  duration: '3h 30m',
  flights: 14
}];
export default HomePage;